import Swiper from "swiper";
import "swiper/css";

export default function () {
    const roots = document.querySelectorAll(
        '.o-voz__swiper[data-swiper="voz"]',
    );
    if (!roots.length) return;

    const instances = [];

    roots.forEach((root) => {
        if (root.dataset.swiperInitialized === "true") return;

        const slides = parseInt(root.dataset.slides || "1", 10);

        const slider = new Swiper(root, {
            slidesPerView: 1.25,
            spaceBetween: 12,
            autoHeight: false,
            breakpoints: {
                768: {
                    slidesPerView: Math.min(slides, 3),
                    spaceBetween: 12,
                },
                1024: {
                    slidesPerView: slides,
                    spaceBetween: 14,
                },
            },
        });

        root.dataset.swiperInitialized = "true";
        instances.push(slider);
    });

    return instances;
}
